/**
 * 全局存储用户topic信息 user_id@user_source：topic
 * @type {{}}
 * @private
 */
let _globaldic = {};

export default {
  get: function (key) {
    return _globaldic[key];
  },
  set: function (key, value) {
    _globaldic[key] = value;
  }
};

